import backend from "../../../../backend/backend";
import label from "../../../../i18n/label";
import Notify from "../../../shared/Notify";
import VendorKeyActions from "./VendorKeyActions";

export const createVendorKey = (
  intl,
  vendorKey,
  workspaceId,
  onSuccess,
  onError
) => {
  return (dispatch) => {
    backend
      .createVendorKey(vendorKey, workspaceId)
      .then((data) => {
        //console.log("loaded workspaces", data);
        dispatch({
          type: VendorKeyActions.LIST_CHANGED,
        });
        onSuccess && onSuccess(data);
      })
      .catch((err) => {
        onError && onError(err);
        console.error("Failed to create a vendor key", err);
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};

export const loadVendorKeys = (intl, workspaceId, onSuccess, onError) => {
  return (dispatch) => {
    backend
      .getVendorKeys(workspaceId)
      .then((data) => {
        console.log("loaded api keys", data);
        dispatch({
          type: VendorKeyActions.LIST_LOADED,
          list: data,
        });
        onSuccess && onSuccess(data);
      })
      .catch((err) => {
        onError && onError(err);
        console.error("Failed to load vendor keys", err);
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};

export const loadVendorKey = (intl, workspaceId, id, onSuccess, onError) => {
  return (dispatch) => {
    backend
      .getVendorKey(workspaceId, id)
      .then((data) => {
        //console.log("loaded workspaces", data);
        dispatch({
          type: VendorKeyActions.LOADED,
          key: data,
        });
        onSuccess && onSuccess(data);
      })
      .catch((err) => {
        onError && onError(err);
        console.error("Failed to load a vendor key", err);
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};

export const updateVendorKey = (
  intl,
  workspaceId,
  uid,
  vendorKey,
  onSuccess,
  onError
) => {
  return (dispatch) => {
    backend
      .updateVendorKey(workspaceId, uid, vendorKey)
      .then((data) => {
        //console.log("loaded workspaces", data);
        dispatch({
          type: VendorKeyActions.UPDATED,
          key: data,
        });
        onSuccess && onSuccess(data);
      })
      .catch((err) => {
        onError && onError(err);
        console.error("Failed to update a vendor key", err);
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};

export const deleteVendorKey = (intl, workspaceId, uid, onSuccess, onError) => {
  return (dispatch) => {
    backend
      .deleteVendorKey(workspaceId, uid)
      .then((data) => {
        dispatch({
          type: VendorKeyActions.LIST_CHANGED,
        });
        onSuccess && onSuccess(data);
      })
      .catch((err) => {
        onError && onError(err);
        console.error("Failed to delete a vendor key", err);
        Notify.error(label(intl, "error_unexpected"));
      });
  };
};
